import { useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

import { useOrganizations } from '@cast/shared-organization-context-data-access';
import { QueryOptions } from '@cast/shared-types';
import { KentListFeatureCompatibilitiesResponse } from '@cast/types-kent';
import { makeIsEnabled } from '@cast/utils';

const KENT_FEATURES_COMPATIBILITY_QUERY_KEY = 'kent-features-compatibility';

const getFeaturesCompatibilityQueryKey = (clusterId?: string) =>
  clusterId
    ? [KENT_FEATURES_COMPATIBILITY_QUERY_KEY, clusterId]
    : [KENT_FEATURES_COMPATIBILITY_QUERY_KEY];

type Params = {
  clusterId: string;
};

type GetFeaturesCompatibilityQueryArgs = {
  params: Params;
  options?: QueryOptions<KentListFeatureCompatibilitiesResponse>;
};

export const useGetFeaturesCompatibilityQuery = ({
  params,
  options,
}: GetFeaturesCompatibilityQueryArgs) => {
  const { currentOrganization } = useOrganizations();
  const organizationId = currentOrganization?.id;

  return useQuery({
    queryKey: getFeaturesCompatibilityQueryKey(params.clusterId),
    queryFn: async () => {
      const { data } = await apiClient.kent.getClusterFeaturesCompatibility({
        organizationId: organizationId!,
        clusterId: params.clusterId,
      });
      return data;
    },
    ...options,
    enabled: makeIsEnabled(
      !!params.clusterId,
      !!organizationId,
      options?.enabled
    ),
  });
};
